import React, { useState, useRef ,useEffect} from 'react';
import DatePicker from "react-datepicker";
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
// import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';


// 나의 결재 요청 화면 
const Report002 = () => {
	const { t,i18n }          						  = useTranslation();
	const oneMonthAgo         						  = new Date();
	const [startDate, setStartDate]                   = useState(oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1));
	
	
	// 시작일 값 변경
	const handleChangeStartDate = (date) => {
		setStartDate(date);
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = async () => {
		// setLoading(true);
	
		// API 호출 부분
		// try {
		// 	const data = await API.fetchSanc001Data({			
		// 	});

		// } catch (error) {
		// 	console.error('Error in fetchSanc002DataUpdateState:', error);
		// 	// setLoading(false);
		// }
	};

	useEffect(() => {		
		handleQuery();	
	}, [i18n.language,t]);

	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>점포별 대출현황</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					{/* <form action="/" method="POST"> */}
						<div className="row ms-0">
							<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="date_id">
									<i className="bi bi-calendar3"></i> 조회일
								</label>

								<div className="input-group input-daterange">
									<div className='col'>
										<DatePicker
											className='form-control'
											selected={startDate}
											onChange={handleChangeStartDate}
											dateFormat="dd/MM/yyyy"
										/>
									</div>
												
								</div>
							</div>

							<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>
							<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>

							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>


							
							
						</div>
					{/* </form> */}
				</div>
				<div className="panel-body p-3">
					<h4>대출잔고</h4>
					<table className="border-collapse border border-blue-gray-50" style={{ backgroundColor: '#EEF1F4',width: '-webkit-fill-available' }}>
						<thead>
							<tr>
								<th className="bg-blue-gray-50/50 border h-24 min-w-300" rowSpan="2">
									<div className="text-center mt-8">{t(`REPORT.구분`, { defaultValue: '구분' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.전월말`, { defaultValue: '전월말' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.전일`, { defaultValue: '전일' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.당일`, { defaultValue: '당일' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.전일대비`, { defaultValue: '전일대비' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.전월대비`, { defaultValue: '전월대비' })}</div>
								</th>														
							</tr>
							<tr>														
								{/* 전월말의 건수, 금액 */}
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								{/* 추가 헤더 1의 건수, 금액 */}
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="bg-white border h-12">
									<div className="text-center mt-3 mr-2">오토바이</div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>							
							</tr>
							<tr>
								<td className="bg-white border h-12">
									<div className="text-center mt-3 mr-2">자동차</div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
							{/* 나머지 빈 값으로 채우기 */}
							</tr>
								<tr>
									<td className="bg-white border h-12">
										<div className="text-center mt-3 mr-2">부동산</div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12">
										<div className="text-right mt-3 mr-2"></div>
									</td>
									<td className="bg-white border h-12 col-span-2">
										<div className="text-right mt-3 mr-2"></div>
									</td>							
								</tr>
							<tr>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-center mt-3 mr-2">합계</div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
							{/* 나머지 빈 값으로 채우기 */}
							</tr>
							
						</tbody>
					</table>		
				</div>

				<div className="panel-body p-3">
					<h4>A지점</h4>					
					<table className="border-collapse border border-blue-gray-50" style={{ backgroundColor: '#EEF1F4',width: '-webkit-fill-available' }}>
						<thead>
							<tr>
								<th className="bg-blue-gray-50/50 border h-24 min-w-300" rowSpan="2">
									<div className="text-center mt-8">{t(`REPORT.구분`, { defaultValue: '구분' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.1~5일`, { defaultValue: '전월말' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.6~30일`, { defaultValue: '전일' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.31~60일`, { defaultValue: '당일' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.61일~`, { defaultValue: '전일대비' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200" colSpan="2">
									<div className="text-center mt-3">{t(`REPORT.합계`, { defaultValue: '전월대비' })}</div>
								</th>														
							</tr>
							<tr>														
								{/* 전월말의 건수, 금액 */}
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>								
								{/* 추가 헤더 1의 건수, 금액 */}
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`REPORT.건수`, { defaultValue: '건수' })}</div>
								</th>
								<th className="bg-blue-gray-50/50 border h-12 min-w-200">
									<div className="text-center mt-3">{t(`SMS_MANAGEMENT.금액`, { defaultValue: '금액' })}</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="bg-white border h-12">
									<div className="text-center mt-3 mr-2">오토바이</div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>								
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>							
							</tr>
							<tr>
								<td className="bg-white border h-12">
									<div className="text-center mt-3 mr-2">자동차</div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
							{/* 나머지 빈 값으로 채우기 */}
							</tr>
							<tr>
								<td className="bg-white border h-12">
									<div className="text-center mt-3 mr-2">부동산</div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-white border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>							
							</tr>
							<tr>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-center mt-3 mr-2">합계</div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12">
									<div className="text-right mt-3 mr-2"></div>
								</td>
								<td className="bg-blue-gray-50/50 border h-12 col-span-2">
									<div className="text-right mt-3 mr-2"></div>
								</td>
							{/* 나머지 빈 값으로 채우기 */}
							</tr>
							
						</tbody>
					</table>		
				</div>

				{/* 로딩 관련 gif 
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}*/}

				{/* Tabulator */}
				
				
			</Card.Body>
			<div className="card-footer d-flex justify-content-start mt-auto">
				{/* <button type="button" className="btn btn-outline-info mb-1 me-1 w-100px">버튼1</button>
				<button type="button" className="btn btn-outline-success me-1 mb-1 w-100px">버튼2</button> */}
			</div>
			
		</ Card>
	);
};
 
export default Report002;